import "src/pages/Reporting/ReportTemplateEditor/styles_vanilla.css.ts.vanilla.css!=!../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/pages/Reporting/ReportTemplateEditor/styles_vanilla.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA7VWbW-bMBD-nl_hqZrUSSMC8tKU_pjJ2AZcwGbGBNJp_33CYGobCku1RVEi7s53j-_lOfY_Apg_t0Hug187AFqKZRaBwPe_vuwAKGHnjaLjxa-6QSZSyiLgA9hI3ksqiDFlaQTC42ASQ5SngjcMe4gXXETgIVEfpeQCE-EJiGlTR-AyHuGdV2cQ87b3HFQdOFQdEGkMH_3vYPzug28vu9-7vcYc_DPMhtNQOR1OeJJXI0TD4qAsJg_BWV9BXUwd6S9Q84Ji8EBO5Ej8zbRYtzCCHVWw0XfMpeRlBBhnxLjFEPMQDji0UBur2ElB-gQLynIlMSKc7OtM5hEIVO4o8zJC00yOOkzrqoC3SBlNvjEVBEnKWQQQL5qS9Rp-JSIpeOvdoinzS1l4Ss7JyQJ1tkob-lMhp-Lqemts-vkOeH8H5cmEcvGvrQtkQvffoVyGZljro5VCP9uF1tP6ca2Ns1CdveNCKaz0aBhu4s3hQjZIV42V2oE8FsJGTMyyhU6F9LNDRh_zV4hCFMKNBCcqpFsTwyBdIqy1WfsUk_ZSi4KSMAmIjSSb98Lw4yacmhUrSCLfG2cUijGlRyulmn3WYbwutaShzx1uegc648z1RGom0jxkxCg2MJRO0QYC0N4RLNBjL82AB05h1b3_nYOqsxcWu9vV3Ac3fRx0I7tdee9WnjO1EbJyh26FrdyJNFOfUYwJs1z_NNtr6hmXNoQLYGMH6BkY9qThqJ7xzyyWXFiHiszUrGeyLPYIipgz4tWywZR7EEl6Hegm4Ux6NX0jg2PwhZYVFxIyacVolnhguQ3Oqv6f2rqLCb_OamnlyggUFxzl1tnWXgKz7Ha2HnEmCZO1ZXPb8PGm9DoXF_-a2a98vqUfX5f-AMsnmyTGCgAA\"}!../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var carboneStudioActive = 'carbone-studio-active';
export var container = '_1ak9w1ku';
export var drawerBody = '_1ak9w1k5';
export var drawerContentArea = '_1ak9w1k9';
export var drawerHeader = '_1ak9w1k4';
export var drawerShell = '_1ak9w1k6';
export var drawerShellWide = '_1ak9w1k7';
export var drawerTabs = '_1ak9w1k8';
export var footer = '_1ak9w1k3';
export var formCard = '_1ak9w1k0';
export var hidden = '_1ak9w1kw';
export var instructionStep = '_1ak9w1kc';
export var instructionStepContent = '_1ak9w1kd';
export var instructionsCard = '_1ak9w1ka';
export var instructionsSteps = '_1ak9w1kb';
export var loadingCenter = '_1ak9w1k10';
export var pdfViewer = '_1ak9w1kr';
export var previewDuplicateWrapper = '_1ak9w1kn';
export var previewFieldsContainer = '_1ak9w1k2';
export var previewFormSidebar = '_1ak9w1ko';
export var previewIcon = '_1ak9w1kq';
export var previewPanel = '_1ak9w1kp';
export var previewPublishBody = '_1ak9w1kt';
export var previewPublishWrapper = '_1ak9w1km';
export var previewSelectsContainer = '_1ak9w1ks';
export var publishSuccessContent = '_1ak9w1kz';
export var queryReferenceCard = '_1ak9w1kg';
export var queryReferenceCardHeader = '_1ak9w1kh';
export var queryReferenceEmpty = '_1ak9w1kl';
export var queryReferenceFieldTabs = '_1ak9w1ki';
export var queryReferenceGridContainer = '_1ak9w1kk';
export var queryReferenceToolbar = '_1ak9w1kj';
export var stepContentHidden = '_1ak9w1ky';
export var stepContentVisible = '_1ak9w1kx';
export var stepCounter = '_1ak9w1ke';
export var stepCounterLabel = '_1ak9w1kf';
export var studio = '_1ak9w1kv';
export var updateSettingsWrapper = '_1ak9w1k1';